const toBRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
const toUSD = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

const formatBrl = (inputNumber: number) => toBRL.format(inputNumber);
const formatUsd = (inputNumber: number) => toUSD.format(inputNumber);

export { formatUsd, formatBrl };
